export default class Redsys {
    private cryptojs: any = require('crypto-js');
    private base64url: any = require('base64url');

    public getRandomOrderId(): string {
        const length: number = 12;
        const timestamp = +new Date();

        const getRandomInt = (min: number, max: number) => {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };

        const parts = timestamp.toString().split('').reverse();
        let result = '';

        for (let i = 0; i < length; ++i) {
            const index = getRandomInt(0, parts.length - 1);
            result += parts[index];
        }

        return result;
    }

    public createMerchantParameters(data: any): string {
        return Buffer.from(JSON.stringify(data).replace(/\//g, '\\/'), 'utf8').toString('base64');
    }

    public decodeMerchantParameters(data: string): any {
        const decodedData: any = JSON.parse(this.base64url.decode(data, 'utf8'));
        return decodedData;
    }

    public createMerchantSignature(key: string, data: any): string {
        // Base64 encoding of parameters
        const merchantWordArray = this.cryptojs.enc.Utf8.parse(JSON.stringify(data).replace(/\//g, '\\/'));
        const merchantBase64 = merchantWordArray.toString(this.cryptojs.enc.Base64);

        // Decode key
        const keyWordArray = this.cryptojs.enc.Base64.parse(key);

        // Generate transaction key
        const cipher = this.cryptojs.TripleDES.encrypt(data.Ds_Merchant_Order || data.DS_MERCHANT_ORDER, keyWordArray, {
            iv: this.cryptojs.enc.Hex.parse('0000000000000000'),
            mode: this.cryptojs.mode.CBC,
            padding: this.cryptojs.pad.ZeroPadding,
        });

        // Sign
        const signature = this.cryptojs.HmacSHA256(merchantBase64, cipher.ciphertext);
        const signatureBase64 = signature.toString(this.cryptojs.enc.Base64);

        return signatureBase64;
    }

    public createMerchantSignatureNotif(key: string, data: string): string {
        const decodedData = this.decodeMerchantParameters(data);

        // Base64 encoding of parameters
        const merchantWordArray = this.cryptojs.enc.Utf8.parse(JSON.stringify(decodedData));
        const merchantBase64 = merchantWordArray.toString(this.cryptojs.enc.Base64);

        // Decode key
        const keyWordArray = this.cryptojs.enc.Base64.parse(key);

        // Generate transaction key
        const cipher = this.cryptojs.TripleDES.encrypt(decodedData.Ds_Order || decodedData.DS_ORDER, keyWordArray, {
            iv: this.cryptojs.enc.Hex.parse('0000000000000000'),
            mode: this.cryptojs.mode.CBC,
            padding: this.cryptojs.pad.ZeroPadding,
        });

        // Sign
        const signature = this.cryptojs.HmacSHA256(merchantBase64, cipher.ciphertext);
        const signatureBase64 = signature.toString(this.cryptojs.enc.Base64);

        return this.base64url.encode(signatureBase64, 'base64');
    }

    public merchantSignatureIsValid(signA: string, signB: string): boolean {
        return this.base64url.decode(signA, 'base64') === this.base64url.decode(signB, 'base64');
    }
}

export const redsys = new Redsys();
